import { useEffect } from 'react'
import { useAtom, useSetAtom } from 'jotai'
import { Center, Loader, Stack, Text } from '@mantine/core'
import { authHydratedAtom, authTokenAtom, authUserAtom } from '../../atoms/authAtoms'
import apiClient from '../../lib/apiClient'

export function AuthInitializer({ children }) {
  const [hydrated, setHydrated] = useAtom(authHydratedAtom)
  const [token] = useAtom(authTokenAtom)
  const setUser = useSetAtom(authUserAtom)

  useEffect(() => {
    if (token) {
      // Validate the stored JWT against the backend AND refresh the cached user.
      // /current_user returns the full UserSerializer payload; storing it keeps
      // the cached user current with server-side changes (new roles like
      // facilitated_groups, theme, a11y, etc.) without forcing a re-login. An
      // invalid token is handled by the apiClient interceptor (clear + redirect).
      apiClient.get('/current_user')
        .then((res) => {
          const fresh = res?.data?.data || res?.data
          if (fresh && fresh.id) setUser(fresh)
        })
        .catch(() => {})
        .finally(() => setHydrated(true))
    } else {
      setHydrated(true)
    }
  }, [setHydrated, setUser, token])

  if (!hydrated) {
    return (
      <Center style={{ minHeight: '100vh' }}>
        <Stack align="center" gap="md">
          <Loader size="lg" color="cyan" />
          <Text c="dimmed" size="sm" ff="Orbitron, sans-serif">
            Initializing...
          </Text>
        </Stack>
      </Center>
    )
  }

  return children
}
